import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '../../utils/auth';
import { PaginatedRequestType } from '../../types/pagination';
import { OfferDetail } from '../../types/jobOffer';
import { GetPrivateOffersParams } from './types';

// Define a service using a base URL and expected endpoints
export const privateOffersApi = createApi({
  reducerPath: 'privateOffersApi',
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    // Managment
    getOffers: builder.query<
      PaginatedRequestType<OfferDetail>,
      GetPrivateOffersParams
    >({
      query: (params) => ({
        url: '/offers/private',
        params,
      }),
    }),
    getPrivatesCount: builder.query<number, void>({
      query: () => ({
        url: 'applications/notify',
      }),
      transformResponse: (response: any) => response?.applicationsCounter || 0,
    }),
    rejectPrivateOffer: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `/offers/${id}`,
        body: {
          status: 'rejected',
        },
        method: 'PUT',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOffersQuery,
  useGetPrivatesCountQuery,
  useRejectPrivateOfferMutation,
} = privateOffersApi;
